import type { User } from '@uturn/api/v1';
import { loadUsetifulScript, setUsetifulTags } from 'usetiful-sdk';

const usetifulToken = import.meta.env.VITE_USETIFUL_API_KEY;

export class Usetiful {
	static init() {
		setUsetifulTags({ platform: 'nexturn' });
		loadUsetifulScript(usetifulToken, { identifyUser: true });
	}

	static identify(user: User) {
		setUsetifulTags({
			userId: user.userId,
			firstName: user.firstName,
			role: user.role,
			...(user.organisation && {
				organisationId: user.organisation.id,
				organisationName: user.organisation.name,
				organisationType: user.organisation.organisationType,
			}),
		});

		window.USETIFUL?.user?.setId?.(user.userId);
		window.USETIFUL?.reinitialize?.();
	}
}
